// dev url
export const URLKpostLogin = 'https://devapi2.kpostindia.com/v2'

export const LocalURL= `http://192.168.0.51:2503/api/v1`

// export const LoginURL = `http://localhost:2523/api/v1` // prasithya Local Dashboard URL

// export const LoginURL = `https://him-divx-dentists-aims.trycloudflare.com/api/v1` // prasithya Local Dashboard URL

// export const LoginURL = `http://localhost:2545/api/v1` // Dhanush Local Dashboard URL

export const LoginURL = `https://api.library.kmedglobal.com/api/v1`

 export const LoginURLss = `https://api.kadjournal.com/api/v1`

// KatBook store API (book catalogue + filters)
export const KatBookURL = `https://api.katbookstore.com/api/v1`

export const KatBookURLs = `https://api.katbookstore.com/api/v2`

// Default category used by the Book Mapping screen
export const BookMappingCategoryId = `6ab768822de1d33fc25171e0`
